import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteBlockDateActions } from "store/ducks/settings/block-dates";

export function* deleteBlockDateRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(api.delete, `/block-dates/${id}`);

    const { data } = responseBody;
    yield put(DeleteBlockDateActions.success(data));
    notify("success", "Horário deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteBlockDateActions.failure(errorMessage));
  }
}
